import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import useToasts from '@modules/ToastModule/useToasts';
import { UserStatusMenu } from '@modules/UserStatusModule/components/UserStatusMenu';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import { Button, Flex } from '@servicetitan/anvil2';
import IconArrowOutward from '@servicetitan/anvil2/assets/icons/material/round/arrow_outward.svg';
import NavBarLogo from '@assets/chrome/navbar-logo.svg';
import ContactCenterTitle from '@assets/contact-center-title.svg';
import { PipCallBarManager } from './PipCallBarManager';
import { PipCallCard } from './PipCallCard';
import { PipIncomingCall } from './PipIncomingCall';
import { PIP_EVENTS } from '../constants';
import { pipLocators } from '@locators/pip';
import { getTestIdProps } from '@lib/testUtils';
import styles from '../styles/pip.module.css';

export function PipContent() {
  const { serviceName, user } = useAuth();
  const { callList } = usePhoneState();
  const { incomingCallToasts } = useToasts();

  const activeCall = callList.find((call) =>
    call.direction === 'terminating'
      ? call.hasSession && call.established
      : call.hasSession,
  );
  const hasActiveCall = !!activeCall;
  const hasIncomingCalls = incomingCallToasts.length > 0;

  return (
    <Flex
      direction='column'
      gap='3'
      className={`${styles.pipContainer} p-3`}
      {...getTestIdProps(pipLocators.container)}
    >
      <Flex direction='column' className={styles.headerBar}>
        <Flex
          alignItems='center'
          justifyContent='center'
          gap='2'
          className={styles.logoSection}
        >
          <NavBarLogo />
          <ContactCenterTitle />
        </Flex>
        <Flex alignItems='center' justifyContent='center' gap='3'>
          <span className={styles.serviceName}>{serviceName}</span>
          <UserStatusMenu />
        </Flex>
      </Flex>

      {hasActiveCall && (
        <>
          <PipCallCard callId={activeCall.callId} />
          <PipCallBarManager />
        </>
      )}

      {!hasActiveCall &&
        hasIncomingCalls &&
        incomingCallToasts.map((toast) => (
          <PipIncomingCall key={toast.id} callToast={toast} />
        ))}

      {!hasActiveCall && !hasIncomingCalls && (
        <Flex
          direction='column'
          alignItems='center'
          justifyContent='center'
          gap='1'
          className={styles.idleState}
        >
          {user?.name && <span className={styles.userName}>{user.name}</span>}
          <span className={styles.idleText}>No active call</span>
          <Button
            appearance='secondary'
            icon={{ before: IconArrowOutward }}
            className='m-t-3'
            onClick={() => {
              window.focus();
              window.dispatchEvent(new Event(PIP_EVENTS.OPEN_OUTBOUND_CALL));
            }}
          >
            Make a Call
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
